import { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import Layout from './Layout';
import Pager from '../components/Pager';

const API = process.env.REACT_APP_API_URL || 'http://127.0.0.1:8000';
const LIMIT = 30;

function fmtDate(str) {
  if (!str) return '—';
  return new Date(str).toLocaleString('ru', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' });
}

// N-062: полный список уведомлений с датой/временем получения и прочтения.
// Доступ только по кнопке "Посмотреть все" в колокольчике — своего пункта в меню нет.
export default function Notifications() {
  const [items, setItems] = useState(null);
  const [total, setTotal] = useState(0);
  const [offset, setOffset] = useState(0);

  const headers = { Authorization: 'Bearer ' + localStorage.getItem('token') };

  const load = useCallback(() => {
    axios.get(`${API}/auth/me/notifications`, { headers, params: { limit: LIMIT, offset } })
      .then(r => { setItems(r.data.items); setTotal(r.data.total); })
      .catch(() => {});
  }, [offset]); // eslint-disable-line

  useEffect(() => { load(); }, [load]);

  return (
    <Layout>
      <h1 style={s.h1}>Уведомления</h1>
      <div style={s.tableCard}>
        {!items ? <div style={s.empty}>Загрузка…</div> : items.length === 0 ? (
          <div style={s.empty}>Уведомлений пока нет</div>
        ) : items.map(n => (
          <div key={n.id} style={s.row}>
            <div style={s.rowTitle}>{n.title}</div>
            <div style={s.rowBody}>{n.body}</div>
            <div style={s.rowMeta}>
              <span>Получено: {fmtDate(n.created_at)}</span>
              <span>Прочитано: {n.read_at ? fmtDate(n.read_at) : '—'}</span>
            </div>
          </div>
        ))}
      </div>
      {items && items.length > 0 && <Pager total={total} limit={LIMIT} offset={offset} onPage={setOffset} />}
    </Layout>
  );
}

const s = {
  h1: { color: '#1B2B4B', fontSize: 28, fontWeight: 800, margin: '0 0 20px' },
  tableCard: { background: '#fff', borderRadius: 16, padding: '8px 8px', boxShadow: '0 4px 16px rgba(27,43,75,0.06)' },
  row: { padding: '14px 16px', borderBottom: '1px solid #f4f7fb' },
  rowTitle: { color: '#1B2B4B', fontWeight: 700, fontSize: 15, marginBottom: 4 },
  rowBody: { color: '#475569', fontSize: 13.5, lineHeight: 1.5, whiteSpace: 'pre-wrap', marginBottom: 8 },
  rowMeta: { display: 'flex', gap: 20, color: '#94a3b8', fontSize: 12 },
  empty: { color: '#94a3b8', textAlign: 'center', padding: '32px 0', fontSize: 14 },
};
